import { errorMessageRu, isReauthRequired, isTotpRequired } from '../api/errors';

export type PromptReauth = (reasonRu?: string) => Promise<boolean>;

/**
 * Runs a request; if the server demands a fresh authentication (or a TOTP
 * code) it opens the re-auth modal and, on success, retries **the same
 * request with the same idempotency key**. That is what makes the retry safe:
 * if the first attempt somehow did reach the venue, the replay is rejected by
 * the key rather than duplicating an order.
 */
export async function withReauth<T>(run: () => Promise<T>, promptReauth: PromptReauth): Promise<T> {
  try {
    return await run();
  } catch (error) {
    if (!isReauthRequired(error) && !isTotpRequired(error)) throw error;
    const confirmed = await promptReauth(errorMessageRu(error));
    if (!confirmed) throw error;
    return await run();
  }
}
